import React from 'react';
import { render } from '@testing-library/react';
import { Mask } from './Mask';
import { Page } from '../Page';
import { Card } from '../Card';
import { Headline } from '../Headline';
import { BodyText } from '../BodyText';

describe('Mask', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Mask data-auto-sel="automation-selector">
				<Page>
					<Card>
						<Headline className="m-b-1">Card Title</Headline>
						<BodyText className="m-b-2">
							Lorem ipsum dolor sit amet
						</BodyText>
					</Card>
				</Page>
			</Mask>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
